import {SpaceProto} from "../space-proto";
import {NavigationButtonPosition, NavigationSectionType} from "../../navigation/@const";
import Navigation_ButtonGenericDeprecated from "../../../../layout/navigation/buttons/generic-section";
import {UIType} from "../../../../layout/ui/@const";


export class SpaceHelp extends SpaceProto {

    constructor() {
        super(NavigationSectionType.HELP)

        this.title              = "Help"
        this.svgIcon            = "isvg-help-support"

        this.defaultPosition    = NavigationButtonPosition.MORE

        switch (gd.ui.type) {

            case UIType.ASANA:
            case UIType.TEAMS:
                this.positions = []
                break

            default:
                break
        }

    }

    get position() {
        // patch
        if (gd.ui.type === UIType.ASANA || gd.ui.type === UIType.TEAMS) {
            return NavigationButtonPosition.STATIC
        }

        return super.position
    }

    set position(position) {
        super.position = position
    }

    onClick = () => {
        gd.navigation.goTo('app-help')
    }

    get navigationStructureConfig() {

        return {
            id              : NavigationSectionType.HELP,
            type            : NavigationSectionType.HELP,
            icon            : "i5-nav-support",
            hint            : "Help",
            renderComponent : Navigation_ButtonGenericDeprecated,
            onClick         : this.onClick,
            position        : this.position
        }

    }



}
